import { fetchCurrentUser } from '../../ducks/user.duck';
import { getWhopPayoutTotal, getMyWhopPayouts } from '../../util/api';

// ================ Action types ================ //

export const FETCH_TOTAL_REQUEST = 'app/EarningsPage/FETCH_TOTAL_REQUEST';
export const FETCH_TOTAL_SUCCESS = 'app/EarningsPage/FETCH_TOTAL_SUCCESS';
export const FETCH_TOTAL_ERROR = 'app/EarningsPage/FETCH_TOTAL_ERROR';
export const FETCH_HISTORY_REQUEST = 'app/EarningsPage/FETCH_HISTORY_REQUEST';
export const FETCH_HISTORY_SUCCESS = 'app/EarningsPage/FETCH_HISTORY_SUCCESS';
export const FETCH_HISTORY_ERROR = 'app/EarningsPage/FETCH_HISTORY_ERROR';

// ================ Reducer ================ //

const initialState = {
  totalPaidOutUsd: null,
  fetchTotalInProgress: false,
  payoutHistory: [],
  // Netted statement from the server: earned, paid out, pending, and anything a
  // refund is taking back off the next payout.
  ledger: null,
  fetchHistoryInProgress: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TOTAL_REQUEST:
      return { ...state, fetchTotalInProgress: true };
    case FETCH_TOTAL_SUCCESS:
      return { ...state, fetchTotalInProgress: false, totalPaidOutUsd: payload };
    case FETCH_TOTAL_ERROR:
      return { ...state, fetchTotalInProgress: false };
    case FETCH_HISTORY_REQUEST:
      return { ...state, fetchHistoryInProgress: true };
    case FETCH_HISTORY_SUCCESS:
      return {
        ...state,
        fetchHistoryInProgress: false,
        payoutHistory: payload.rows,
        ledger: payload.ledger,
      };
    case FETCH_HISTORY_ERROR:
      return { ...state, fetchHistoryInProgress: false };
    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchTotalRequest = () => ({ type: FETCH_TOTAL_REQUEST });
const fetchTotalSuccess = total => ({ type: FETCH_TOTAL_SUCCESS, payload: total });
const fetchTotalError = () => ({ type: FETCH_TOTAL_ERROR });
const fetchHistoryRequest = () => ({ type: FETCH_HISTORY_REQUEST });
const fetchHistorySuccess = payload => ({ type: FETCH_HISTORY_SUCCESS, payload });
const fetchHistoryError = () => ({ type: FETCH_HISTORY_ERROR });

// ================ Thunks ================ //

export const fetchEarnings = () => dispatch => {
  dispatch(fetchTotalRequest());
  dispatch(fetchHistoryRequest());

  const totalPromise = getWhopPayoutTotal()
    .then(response => dispatch(fetchTotalSuccess(Number(response && response.totalPaidOutUsd) || 0)))
    .catch(() => dispatch(fetchTotalError()));

  const historyPromise = getMyWhopPayouts()
    .then(response =>
      dispatch(
        fetchHistorySuccess({
          rows: (response && response.rows) || [],
          ledger: (response && response.ledger) || null,
        })
      )
    )
    .catch(() => dispatch(fetchHistoryError()));

  return Promise.all([totalPromise, historyPromise]);
};

export const loadData = () => dispatch => {
  dispatch(fetchCurrentUser());
  return dispatch(fetchEarnings());
};
